import { Component, OnInit } from '@angular/core';
//@ts-ignore
import { topMenuBarItems } from '../../../assets/constants/menu'

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  loginButton=false
  logoImg=`../../../assets/imgs/logo/se2in_logo.png`
  public navItems: any = topMenuBarItems;
  constructor() { }
 

  ngOnInit(): void {
  }
}